import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore.js'
import { useEffect } from 'react'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, token, isTokenExpired, logout } = useAuthStore()
  const location = useLocation()

  // Vérification active de l'expiration
  const isExpired = token && isTokenExpired(token)

  useEffect(() => {
    if (isExpired && isAuthenticated) {
      logout()
    }
  }, [isExpired, isAuthenticated, logout])

  if (!isAuthenticated || isExpired) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return children
}

export default ProtectedRoute
